/* Instruments */
import { authSlice, ChatSlice } from "./slices";

export const reducer = {
  Auth: authSlice.reducer,
  Chat: ChatSlice.reducer,
};
